<template>
    <div>
        <vs-divider>
            {{ customerKnow.title }}
        </vs-divider>

        <div class="mt-3" v-for="(item, index) in customerKnow.reason_option">

            <div v-if="item.type === 'boolean'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <vs-switch :value="item.value" :disabled="true"/>
            </div>

            <div v-if="item.type === 'checkbox'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <vs-checkbox 
                :disabled="true"
                v-for="(tr, index) in item['option_items']"
                :value="tr.activated"
                >
                    {{ tr.description }}
                </vs-checkbox>
            </div>

            
            <div v-if="item.type === 'radio'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <span v-for="(tr, index) in item['option_items']">
                    <vs-radio
                    :disabled="true"
                    v-model="vsRadio"
                    :vs-name="vsRadio"
                    :vs-value="tr.description"
                    >
                        {{ tr.description }}
                    </vs-radio>
                    <br>
                </span>
            </div>

            <div v-if="item.type === 'select'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <vs-select
                disabled="true"
                class="selectExample"
                v-model="select"
                >
                    <vs-select-item :value="1" :text="item.value"/>
                </vs-select>
            </div>

            <div v-if="item.type === 'decimal'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <vs-input 
                type="number" 
                disabled 
                :value="item.value"
                />
            </div>

            <div v-if="item.type === 'currency'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <div class="flex currency-input-class">
                    <span class="p-2 pr-0" style="font-size: 13.8px;">R$</span>
                    <vs-input 
                        v-model="item.value" 
                        id="currency-input"
                        disabled
                    />          
                </div> 
            </div>

            <div v-if="item.type === 'text'">
                <h4 class="mt-4 mb-1">{{ item.label }}</h4>
                <vs-input 
                disabled 
                :value="item.value"
                />
            </div>

        </div>
        
        <vs-textarea
          v-if="customerKnow.observation !== 'null'"
          name="observation" 
          class="w-full mt-5" 
          label="Observações" 
          v-model="customerKnow.observation"
          :disabled="true"
        />
    </div>
</template>

<script>
    
    export default {
        name: 'OrderCustomerKnowInfos',
        data() {
            return {
                vsRadio: '',
                select:1,
            }
        },
        props: {
            customerKnow: {
                type: Object,
                required: true,
            },
        },
        mounted() {
            for (var key in this.customerKnow.reason_option) {
                if (this.customerKnow.reason_option.hasOwnProperty(key)) {
                    var optionItem = this.customerKnow.reason_option[key];
                
                    if (optionItem.type === 'checkbox') {
                        const values = optionItem.value.split(",")
                        
                        optionItem.option_items.forEach(element => {
                            element.activated = values.includes(element.description) ? true : false;
                        });
                    }
                    else if (optionItem.type === 'radio'){
                        this.vsRadio = optionItem.value
                    }
                }
            }
        }
    }
</script>


<style lang="scss" >
  #currency-input {
        width: 115px;
        box-shadow: none !important;
        background-color: transparent;        
        font-size: 15px;
        background-color: transparent; 
        border: none !important;
    }
    .currency-input-class {
        width:200px !important; 
        border: 1px solid #b6bebd95 !important; 
        border-radius: 7px !important;
    }
</style>
